import type translations from "../../../translations/translations.json";
import { TruckStatus } from "../../../types/truck";

type TranslationKeys = keyof typeof translations.en;

export const formatLicensePlate = (licensePlate: string): string => {
  // Match the pattern: letter(s) + number(s) + letter(s)
  const match = licensePlate.match(/^([A-z]+)(\d+)([A-z]+)$/);
  if (match) {
    const [, letters1, numbers, letters2] = match;
    return `${letters1} ${numbers} ${letters2}`;
  }
  return licensePlate;
};

export const getStatusColor = (status: TruckStatus) => {
  switch (status) {
    case TruckStatus.UNKNOWN:
    case TruckStatus.RETIRED:
      return "default";
    case TruckStatus.ON_WORK:
      return "success";
    case TruckStatus.MOB:
      return "warning";
    case TruckStatus.MAINTENANCE:
      return "error";
    case TruckStatus.STANDBY:
      return "info";
    default:
      return "default";
  }
};

export const formatDate = (dateString: string, language: string) => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleString(language, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  // Replace any time separator with a colon
  return formattedDate.replace(/(\d{2})[.,](\d{2})/, "$1:$2");
};

export type { TranslationKeys };
